import React from "react";
import { useEffect } from "react";
import { Button, Loader, Theme, ThemeProvider, useTheme, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import {v4} from 'uuid'

function FaceLivenessTheme({faceLivenessAnalysis, tryAgain}) {
    const [loading, setLoading] = React.useState(true);
    const [sessionId, setSessionId] = React.useState(null)
   
    const url = 'https://d2wy6f5rfc3jf3.cloudfront.net/api/liveness';

   /*
   * Create the Face Liveness Session
   */
   const fetchCreateLiveness = async () => {
      const body = {
        eventId: v4()
      };
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      console.log(`sessionId: ${data.sessionId}`);
      setSessionId(data.sessionId)
      setLoading(false);

    };

    useEffect(() => {
        fetchCreateLiveness();
    },[])

   /*
   * Get the Face Liveness Session Result
   */
    const handleAnalysisComplete = async () => {
        const response = await fetch(`${url}/${sessionId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        faceLivenessAnalysis(data)
    };

    const handleError = async (livenessError) => {
      console.log(livenessError);
    }

    const handleClick = () => {
      setSessionId(null);
      setLoading(true);
      fetchCreateLiveness();
      tryAgain();
    }

    const { tokens } = useTheme();
    const theme: Theme = {
      name: 'Face Liveness Example Theme',
      tokens: {
        colors: {
          background: {
            primary: {
              value: tokens.colors.neutral['90'].value,
            },
            secondary: {
              value: tokens.colors.neutral['100'].value,
            },
          },
          font: {
            primary: {
              value: tokens.colors.white.value,
            },
          },
          brand: {
            primary: {
              '10': tokens.colors.teal['100'],
              '80': tokens.colors.teal['40'],
              '90': tokens.colors.teal['20'],
              '100': tokens.colors.teal['10'],
            },
          },
        },
      },
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
              <ThemeProvider theme={theme}>
                <FaceLivenessDetector
                    sessionId={sessionId}
                    region="us-east-1"
                    onAnalysisComplete={handleAnalysisComplete}
                    onError={(livenessError) => handleError(livenessError)}
                    components={{
                      ErrorView: ({ children }) => {
                        return (
                          <View flex="1" backgroundColor="white" className="amplify-flex amplify-liveness-overlay amplify-liveness-overlay-opaque">
                            <div className="amplify-liveness-toast amplify-liveness-toast--default amplify-liveness-toast--medium">
                              <div className="amplify-flex amplify-liveness-toast__container">
                                {children}
                                <div className="amplify-flex">
                                  <Button className="amplify-button amplify-field-group__control amplify-button--primary" data-fullwidth="false" data-variation="primary" type="button" onClick={handleClick}>Try again</Button>
                                </div>
                              </div>
                            </div>
                          </View>
                        );
                      },
                    }}                
                />
              </ThemeProvider>
            )}
        </>
    );
}

export default FaceLivenessTheme;
